<template>
  <div>
    <template v-if="info.participant">
      <span>{{ participantSingularName.toUpperCase() }} NAME: {{ info.participant }}</span><br/><br/>
    </template>
    <vue-form-view :schema="schema" :values="values"></vue-form-view>
    <div class="activity-info-container">
      <h4 v-if="info.length != 0" class="activity-info">ACTIVITY LOGGING</h4>
      <span v-if="info.created_date != null">Completed By: <b>{{ info.creator }}</b> at {{ info.created_date.date | formatDate }}<br></span>
      <div v-if="!isEqual(info.created_date, info.updated_date)">
        <span v-html="getEditor(info)"></span>
      </div>
      <span v-if="info.created_date != null" v-html="getCase(info)"></span>
    </div>
  </div>
</template>
<script>
  import VueFormView from '@/components/formbuilder/VueFormView';
  import {HTTP, ERROR} from '@/http-common';
  import participantDisplayName from '@/mixins/participantDisplayName';

  export default {
    mixins: [
      participantDisplayName
    ],
    data() {
      return {
        schema: [],
        values: [],
        info: {}
      }
    },

    mounted() {
      $('body').addClass('white');
      this.getData(this.$route.params.id);
    },

    components: {
      VueFormView
    },

    methods: {
      getData(id) {
        HTTP.post(`/form/print`, {data_id: id})
          .then(response => {
            ERROR(response);
            if (response.data.status == 'success') {
              this.schema = JSON.parse(response.data.data.form.data);
              this.values = response.data.data.values;
              this.info = response.data.data.form_data;
              _.delay(() => {
                window.print();
                //window.close();
              }, 2000);
            }
          })
          .catch(err => {
            console.log(err);
          });

      },
      getEditor(data) {
        if (data.editor != null)
          return 'Modified By: <b>' + data.editor + '</b> at ' + this.$options.filters.formatDate(data.updated_date.date);
      },
      getCase(data) {
        if (data.case_manager === null) {
          return 'Case Manager: <b>Unassigned</b>';
        }

        let str = 'Case Manager: <b>' + data.case_manager + '</b>';

        if (data.secondary_case_manager !== null) {
          str += ', <b>' + data.secondary_case_manager + '</b>';
        }

        return str;
      },
      isEqual(first, second) {
        return JSON.stringify(first) == JSON.stringify(second);
      }
    }

  }
</script>



// WEBPACK FOOTER //
// PrintForm.vue?298aef80